module.exports = __webpack_public_path__ + "static/media/lhx.a7123022.png";